module.exports = {"id":"231571","name":"Jeison Lucumi","rating":"71","photo":"./data/images/photos/1/231571.png","club":{"name":"Atl. Nacional","logo":"./data/images/clubs/Atl.Nacional.png"},"positions":["MOC","AG","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JeisonLucumi0.json
// module id = 1972
// module chunks = 0